/* eslint-disable complexity */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
	headerMobileBackContainerSX,
	headerMobileCloseSearchIconSX,
	headerSearchMobileDrawerContainerSX,
	headerMobileDrawerSX,
} from '@/components/content/Header/styles/mobileDrawer';
import { useNextRouter } from '@/data/Content/_NextRouter';
import { Box, Drawer, Grid, Stack, Typography } from '@mui/material';
import { HeaderSearch, HeaderSearchHandle } from '@/components/content/Header/parts/Search';
import { FC, Fragment, useEffect, useMemo, useRef, useState } from 'react';

import ClearIcon from '@mui/icons-material/Clear';
import { Linkable } from '@/components/blocks/Linkable';
import { useSearchNavigation } from '@/data/Content/SearchNavigation';
import { RenderProductImg } from '@/components/blocks/RenderProductImg';
import { Img } from '@/components/blocks/MaterialImage';
import { PriceProductSearch } from '@/components/content/Header/parts/PriceProductSearch';
import SearchIcon from '@mui/icons-material/Search';
import { HeaderNavBarSuggest } from '@/components/content/Header/parts/HeaderNavBarSuggest';

type Option = {
	label: string;
	href?: string;
	identifier: string;
};

export const SearchMobileDrawer: FC<{
	toggleSearch: any;
	open: boolean;
	navBarRecommendation: JSX.Element;
}> = ({ toggleSearch, open, navBarRecommendation }) => {
	const router = useNextRouter();
	const [suggest, setSuggest] = useState<any[]>([]);
	const { onSubmit } = useSearchNavigation();
	const headerSearchRef = useRef<HeaderSearchHandle>(null);
	const [searchValueExternal, setSearchValueExternal] = useState<string>('');
	const [suggestProducts, setSuggestProducts] = useState<any[]>([]);

	const options = useMemo<Option[]>(
		() =>
			suggest
				.map(({ identifier, entry }) =>
					identifier && entry
						? entry.map(({ label, href }: { label: string; href?: string }) => ({
								label,
								href,
								identifier,
						  })) || []
						: []
				)
				.flat(1)
				.filter((elm) => elm.identifier === 'Keyword'),
		[suggest]
	);

	const suggestCategories = useMemo<Option[]>(
		() =>
			suggest
				.map(({ identifier, entry }) =>
					identifier && entry
						? entry.map(({ label, href }: { label: string; href: string }) => ({
								label,
								href,
								identifier,
						  })) || []
						: []
				)
				.flat(1)
				.filter((elm) => elm.identifier === 'Category'),
		[suggest]
	);

	useEffect(() => {
		if (!router.asPath) return;
		toggleSearch(false)();
	}, [router.asPath, toggleSearch]);

	const handleSuggestChange = (newSuggest: any) => {
		setSuggest(newSuggest);
	};

	const handleClearSearchFromNavBar = () => {
		if (headerSearchRef.current) {
			headerSearchRef.current.clearSearch();
		}
	};

	const handleSearchSubmit = (value: { label: string }) => {
		onSubmit(value);
		handleClearSearchFromNavBar();
		toggleSearch(false);
	};

	const handleSearchValue = (newSearchValue: any) => {
		setSearchValueExternal(newSearchValue);
	};

	const handleSuggestProductsChange = (newSuggestProducts: any) => {
		setSuggestProducts(newSuggestProducts);
	};

	return (
		<Drawer
			anchor="left"
			open={open}
			onClose={toggleSearch(false)}
			sx={{
				zIndex: 9003,
				width: '100%',
				'.MuiDrawer-paperAnchorLeft': {
					position: 'absolute',
					width: '100%',
				},
			}}
		>
			<Box sx={headerSearchMobileDrawerContainerSX}>
				<Box sx={headerMobileDrawerSX} role="presentation">
					<Box sx={headerMobileBackContainerSX}>
						<HeaderSearch
							ref={headerSearchRef}
							mobile={true}
							onSuggestChange={handleSuggestChange}
							onSearchValue={handleSearchValue}
							onSuggestProductsChange={handleSuggestProductsChange}
						/>
						<ClearIcon sx={headerMobileCloseSearchIconSX} onClick={toggleSearch(false)} />
					</Box>

					{searchValueExternal.length ? (
						<Stack
							display={'flex'}
							direction={'column'}
							//  spacing={'65px'}
						>
							<Stack display={'flex'} direction={'column'} spacing={1}>
								{options && options.length ? (
									<Typography
										sx={{
											fontSize: 'var(--font-size-body)',
											fontWeight: 'bold',
											color: '#707070',
											letterSpacing: '0px',
										}}
									>
										{'Sugerencias'}
									</Typography>
								) : null}

								<Stack spacing={2} mt={'14px'}>
									{options && options.length
										? options.map(({ label }: { label: string }, index: number) => (
												<HeaderNavBarSuggest
													key={index}
													label={label}
													onClick={() => handleSearchSubmit({ label })}
												/>
										  ))
										: null}
								</Stack>
							</Stack>
							<Stack display={'flex'} direction={'column'} mt={'30px'}>
								<Stack
									display={'flex'}
									direction={'row'}
									spacing={1}
									justifyContent={'space-between'}
									mb={'10px'}
								>
									<Stack
										display={'flex'}
										direction={'row'}
										spacing={1}
										alignItems={'center'}
										width={'70%'}
									>
										<SearchIcon sx={{ fontSize: '28px', fontWeight: 'bold' }} />
										<Typography
											sx={{
												fontSize: 'var(--font-size-md)',
												fontWeight: 'bold',
												overflow: 'scroll',
												'&::-webkit-scrollbar': {
													width: '0px',
													height: '5px',
												},
												'&::-webkit-scrollbar-track': {
													backgroundColor: '#f1f1f1',
												},
												'&::-webkit-scrollbar-thumb': {
													backgroundColor: '#888',
													borderRadius: '10px',
													border: '2px solid #f1f1f1',
												},
												'&::-webkit-scrollbar-thumb:hover': {
													backgroundColor: '#555',
												},
											}}
										>
											{searchValueExternal}
										</Typography>
									</Stack>
									{suggestProducts.length && suggestProducts[0]?.entry ? (
										<Stack display={'flex'} direction={'row'} spacing={1}>
											<Linkable
												onClick={() => handleSearchSubmit({ label: searchValueExternal })}
												href=""
												type="inline"
												sx={{ textDecoration: 'none', '&:hover': { textDecoration: 'none' } }}
											>
												<Typography
													sx={{
														fontSize: 'var(--font-size-body)',
														fontWeight: 'normal',
														color: '#2C2C2C',
													}}
												>
													{'Ver todo'}
												</Typography>
											</Linkable>
										</Stack>
									) : null}
								</Stack>
								<Grid container spacing={2}>
									{suggestProducts.length ? (
										suggestProducts[0].entry.map(
											(
												element: {
													href: string | undefined;
													price: any[];
													thumbnail: string;
													name: string | undefined;
												},
												index: number
											) => (
												<Grid
													item
													xs={6}
													key={index}
													sx={{ backgroundColor: 'transparent', maxWidth: '200px' }}
													direction={'column'}
													// spacing={4}
												>
													<Linkable href={element.href}>
														<RenderProductImg
															fullImageRaw={element.thumbnail}
															render={(src) => (
																<Img
																	src={src}
																	sx={{
																		width: '200px',
																		height: '200px !important',
																		objectFit: 'cover',
																	}}
																	alt={element.name}
																/>
															)}
														/>
														<Typography
															sx={{
																fontSize: 'var(--font-size-body)',
																fontWeight: '600',
																color: '#2C2C2C',
																letterSpacing: '0px',
															}}
														>
															{element.name}
														</Typography>
														<Typography
															sx={{
																fontSize: 'var(--font-size-body)',
																fontWeight: '600',
																color: '#929292',
																letterSpacing: '0px',
															}}
														>
															<PriceProductSearch priceProduct={element.price} />
														</Typography>
													</Linkable>
												</Grid>
											)
										)
									) : headerSearchRef?.current?.isLoading ? (
										<Grid item xs={8} sx={{ backgroundColor: 'transparent' }}>
											<Typography
												sx={{
													fontSize: { xs: 'var(--font-size-md)', md: 'var(--font-size-md)' },
													fontWeight: 'bold',
												}}
											>
												{'Cargando resultados...'}
											</Typography>
										</Grid>
									) : (
										<Grid item xs={6} sx={{ backgroundColor: 'transparent' }}>
											<Typography sx={{ fontSize: 'var(--font-size-md)', fontWeight: 'bold' }}>
												{'Sin coincidencias'}
											</Typography>
										</Grid>
									)}
								</Grid>
							</Stack>
						</Stack>
					) : (
						<Fragment>{navBarRecommendation}</Fragment>
					)}
				</Box>
			</Box>
		</Drawer>
	);
};
